import { createFileRoute, redirect } from '@tanstack/react-router';

import { FEATURE_FLAGS } from 'shared/consts';
import { TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';
import { routes } from 'shared/routes';
import { requireFeatureFlag } from 'shared/utils';

import { LocalSearchGridSettings, requireLsgReport } from 'features/reports/LocalSearchGridSettings';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/lsg/settings')({
  staticData: { breadcrumb: 'localSearchGridSettings' },
  beforeLoad: ({ context, params: { id } }) =>
    requireFeatureFlag(FEATURE_FLAGS.LSG_SETTINGS_ALLOWED, context.authUser.featureAllowance, {
      // With the flag off, the settings address leads back to the location's LSG page.
      onDisabled: () => {
        throw redirect(routes.localSearchGrid(id));
      }
    }),
  loader: ({ context: { queryClient }, params: { id } }) => requireLsgReport({ queryClient, locationId: id }),
  component: LocalSearchGridSettingsRoute
});

function LocalSearchGridSettingsRoute() {
  const { id } = Route.useParams();

  return (
    <ToolAccessGate
      gate={TOOL_GATES.LOCAL_SEARCH_GRID}
      locationId={id}
      page={LOCATION_DATA_UNAVAILABLE_PAGE.LOCAL_SEARCH_GRID}
      titleKey="reports.localSearchGrid.settings.title"
    >
      <LocalSearchGridSettings locationId={id} />
    </ToolAccessGate>
  );
}
